/* Mayekoo Volunteer page — scoped JS for the Community photo lightbox. */
(function () {
  'use strict';

  var existing = window.MayekooVolunteerPage;
  if (existing && typeof existing.scan === 'function') {
    existing.scan(document);
    return;
  }

  var instances = new WeakMap();
  var desktopQuery = window.matchMedia('(min-width: 750px)');

  function communityRoots(scope) {
    var roots = [];
    if (scope && scope.nodeType === 1 && scope.matches('[data-mk-community]')) {
      roots.push(scope);
    }
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-mk-community]')));
    }
    return roots;
  }

  function initCommunity(root) {
    if (!root || instances.has(root)) return;

    var strip = root.querySelector('[data-mk-photostrip]');
    var lightbox = root.querySelector('[data-mk-lightbox]');
    if (!strip || !lightbox) return;

    var image = lightbox.querySelector('[data-mk-lightbox-img]');
    var caption = lightbox.querySelector('[data-mk-lightbox-cap]');
    var closeButton = lightbox.querySelector('[data-mk-lightbox-close]');
    if (!image || !caption || !closeButton) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var lastFocus = null;
    var previousBodyOverflow = '';

    function isOpen() {
      return lightbox.classList.contains('is-open');
    }

    function openLightbox(src, alt, width, height) {
      if (!desktopQuery.matches || !src) return;

      lastFocus = document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      if (width && height) {
        image.width = Number(width);
        image.height = Number(height);
      }
      image.src = src;
      image.alt = alt || '';
      caption.textContent = alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeLightbox(options) {
      if (!isOpen()) return;

      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      caption.textContent = '';
      document.body.style.overflow = previousBodyOverflow;

      if ((!options || options.restoreFocus !== false) && lastFocus && lastFocus.isConnected) {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    strip.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mk-full]');
      if (!button || !strip.contains(button)) return;
      openLightbox(
        button.getAttribute('data-mk-full'),
        button.getAttribute('data-mk-alt'),
        button.getAttribute('data-mk-width'),
        button.getAttribute('data-mk-height')
      );
    }, { signal: signal });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target === closeButton || closeButton.contains(event.target)) {
        closeLightbox();
      }
    }, { signal: signal });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }

      if (event.key === 'Tab') {
        event.preventDefault();
        closeButton.focus();
      }
    }, { signal: signal });

    function handleBreakpointChange(event) {
      if (!event.matches) closeLightbox();
    }

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', handleBreakpointChange, { signal: signal });
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(handleBreakpointChange);
    }

    instances.set(root, {
      destroy: function () {
        closeLightbox({ restoreFocus: false });
        controller.abort();
        if (typeof desktopQuery.removeListener === 'function') {
          desktopQuery.removeListener(handleBreakpointChange);
        }
        instances.delete(root);
      }
    });
  }

  function scan(scope) {
    communityRoots(scope || document).forEach(initCommunity);
  }

  function destroy(scope) {
    communityRoots(scope || document).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  window.MayekooVolunteerPage = {
    scan: scan,
    destroy: destroy
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
})();
